import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import Rotas from './routes/Routes'
import { usePallet } from './contexts/PalletContext';
import LegisPocket, { LegisPocketCarregando } from './pages/legispocket/LegisPocket';
import { useLegisPocketLiberado } from './pages/legispocket/LegisPocket.config';
// import Alerta from './components/Alerta';

function App() {
    const { pallet } = usePallet();

    // Rota pública /legispocket: página de apresentação enviada ao prospectado.
    // Habilitada por HAB_LEGISPOCKET em parametros_cliente, lida via GET /config
    // (rota pública). Resolvida antes do roteador e do pallet para não depender
    // de autenticação. Fora da rota o hook não dispara requisição nenhuma.
    const legisPocket = useLegisPocketLiberado();
    if (legisPocket === 'carregando') return <LegisPocketCarregando />;
    if (legisPocket === 'liberado') return <LegisPocket />;
    // 'bloqueado' (flag false/ausente) e 'fora' seguem o fluxo normal da aplicação

    return (
        <>
            <CssBaseline />
            <div className="App" >
                <header className="App-header" />
                {/* <main className={classes.content}> */}
                {/* <Alerta /> */}
                <BrowserRouter>
                    {!pallet ? <></> : <Rotas />}
                </BrowserRouter>
                {/* </main> */}

            </div>
        </>
    );
}

export default App;
